export default __webpack_public_path__ + "static/media/contrato_adopcion_nuevo.56c387c4.pdf";